import { jsx as _jsx } from "react/jsx-runtime";
import * as S from "./FixedPositionWrapper.style";
/**
 * This wrapper component purely anchors the child component
 * to the bottom-right of the screen, and exists to facilitate
 * clear separation between 'fixed' and 'inline' styles.
 */
const FixedPositionWrapper = _ref => {
  let {
    bottom = "0",
    right = "0",
    children
  } = _ref;
  return _jsx(S.Wrapper, {
    bottom,
    right,
    children: children
  });
};
export default FixedPositionWrapper;
export * as Styles from "./FixedPositionWrapper.style";